import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import API from "../api";
import { store } from "store/index";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import { setAlert } from "action/index";
import PackagesTabs from "components/Packages/Tabs";
import { getCountryForTimezone } from "countries-and-timezones";
import Plans from "page/plans";
import CrackedCodeSlider from "../components/Frontend/Sliders/CrackedCodeSlider";

class FreeMockTest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plans: [],
    };
  }
  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactPixel.init("2474090032742391");
    ReactPixel.init("197333187452630");
    ReactPixel.pageView();
    this.getPackages();

    document.body.classList.add("mock-test-page");
  }

  componentWillUnmount() {
    document.body.classList.remove("mock-test-page");
  }

  getPackages() {
    const country = getCountryForTimezone(
      Intl.DateTimeFormat().resolvedOptions().timeZone
    );
    let countryId = "AU";
    if (country && country.id) {
      countryId = country.id;
    }
    const url =
      import.meta.env.VITE_URL_ALT +
      "/api/v2/getPackages?countryId=" +
      countryId;
    API({
      url: url,
      method: "GET",
    }).then((res) => {
      if (res.status === 200) {
        const { data } = res.data;
        this.setState({ plans: data });
      } else {
        store.dispatch(
          setAlert({ flag: true, type: 2, message: "Something went wrong." })
        );
      }
    });
  }

  render() {
   const CardsSlider = {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      adaptiveHeight: true,
      autoplaySpeed: 5000,
    };
    const CardSlider = {    
      adaptiveHeight: true,
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,      
    };

    return (
      <React.Fragment>
        <Helmet>
          <title>
            Free Pte Mock Test With Score Card & Free PTE Practice Test{" "}
          </title>
          <meta name="twitter:title" content="Language Academy" />
          <meta property="og:title" content="Language Academy" />
          <meta
            name="description"
            content="Ace the Pte exam like a pro with Free Pte Mock Test With Score Card and detailed Feedback and Analysis to get your desired scores based on the Latest PTE Academic pattern!"
          />
        </Helmet>
        <Header />

           <div className="banner-section noc-banner mt-banner">
              <div className="container">
                <div className="row">
                  <div className="banner-content">
                    <div className="banner-inner-content">
                      <h1 className="primary-heading dark-blue-color">
                        <span className="fw-700">STOP FAILING PTE</span>
                        <br className="d-block" /> <span className="light-red-text light-blue-text">
                          AUSTRALIA'S #1
                        </span><br className="d-block d-md-none" /> MOCK TEST <br className="d-none d-md-block" /> PLATFORM GUARANTEES YOUR SUCCESS
                      </h1>
                      <p className="sub-title">
                        Experience real exam conditions with AI-powered scoring that mirrors the actual PTE algorithm, giving you the confidence to achieve your target score.
                      </p>
                    </div>
                    <div className="iframe-video-outer position-relative">
                      <div className="banner-img-wrapper">
                        <img
                          className="banner-img"
                          src="/images/web-new-images/banners/mock-test-banner.png"
                          alt="LA"
                        />
                      </div>
                      <img
                        className="emoji1 position-absolute"
                        src="/images/web-new-images/emojis/hand-emoji.png"
                        alt="LA"
                      />
                      <img
                        className="emoji2 position-absolute"
                        src="/images/web-new-images/emojis/emoji-2.png"
                        alt="LA"
                      />
                      <img
                        className="emoji3 position-absolute"
                        src="/images/web-new-images/emojis/smile-icon11.png"
                        alt="LA"
                      />
                      <img
                        className="emoji4 position-absolute"
                        src="/images/web-new-images/emojis/emoji-4.png"
                        alt="LA"
                      />
                    </div>
                    <div className="light-blue-box">
                      Prepare for PTE success with our comprehensive mock test platform, designed specifically for students, professionals, and immigrants seeking accurate practice and detailed performance analysis.
                      <br />
                      <br />
                    As Australia's leading PTE preparation provider, we offer the most realistic mock test experience available, helping you identify weaknesses, track progress, and achieve your desired scores with confidence.
                    </div>
                    <Link className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        TAKE YOUR FREE MOCK TEST TODAY
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="noc-ccl-exam mt-mock-test">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-12">
                    <h2 className="primary-heading text-center fw-700">
                      WHAT ARE <br className="d-block d-md-none" />
                      <span className="wpl-badge  pte-naati-badge text-white">PTE MOCK TESTS</span>
                      <br className="d-block" />
                      AND WHY DO YOU NEED THEM?
                    </h2>
                  </div>
                  <div className="col-lg-5">
                    <div className="ccl-exam-img">
                      <img
                        src="/images/web-new-images/mock-test-img.png"
                        alt="Register Now"
                      />
                    </div>
                  </div>
                  <div className="col-lg-7">
                    <p className="sub-title fw-300">
                      PTE Mock Tests are comprehensive practice examinations that simulate the real PTE Academic test environment, providing you with authentic preparation experience and detailed performance insights.
                      <br />
                      <br />
                      Our AI-powered mock tests replicate the exact conditions, timing, and question types you'll encounter on test day, ensuring you're fully prepared for every aspect of the examination.
                      <br />
                      <br />
                      Unlike generic practice tests, our mock tests use the same scoring algorithms and assessment criteria as the actual PTE exam, giving you the most accurate prediction of your real test performance.
                    </p>
                  </div>
                </div>
                <div className="pc-skill-areas">
                  <h2 className="pc-pte-core-title">
                    The Complete Mock Test Experience
                  </h2>
                  <div className="skill-areas-content mb-0">
                    <div className="left-area">
                      <h2>Feature</h2>
                      <ul>
                        <li>Real-Time Environment</li>
                        <li>AI-Powered Scoring</li>
                        <li>Detailed Analytics</li>
                        <li>Unlimited Access</li>
                        <li>Expert Feedback</li>
                      </ul>
                    </div>
                    <div className="right-area">
                      <h2>What You Get</h2>
                      <ul>
                        <li>Authentic test conditions with exact timing and interface</li>
                        <li>Instant, accurate scores using actual PTE algorithms</li>
                        <li>Comprehensive breakdown of strengths and weaknesses</li>
                        <li>Practice as often as needed throughout your preparation</li>
                        <li>Personalized improvement strategies from certified trainers</li>
                      </ul>
                    </div>
                  </div>
                  <p className="text-center sub-title my-3 py-3">
                    Transform your preparation from guesswork to precision with mock tests that truly matter.
                  </p>
                  <div className="text-center">
                    <Link className="primary-btn mt-0" to="/auth/register">
                      <span className="btn-inner">
                        START YOUR MOCK TEST PREPARATION
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="pc-why-choose np-need-crack">
              <div className="container">
                <div className="row why-most-second-row">
                  <div className="col-lg-6 why-most-content">
                    <h2 className="primary-heading fw-700 mb-0">
                      5 REASONS
                      <br />
                      <span className="wpl-badge text-white">MOCK TESTS</span>
                      <br />
                      ARE YOUR SECRET WEAPON <br /> FOR PTE SUCCESS
                    </h2>
                    <p className="sub-title my-4 fw-300 text-center text-md-start">Don't walk into your PTE exam unprepared. Mock tests are the difference between hoping for success and guaranteeing it.</p>
                    <div className="text-center text-md-start">
                    <Link className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        EXPERIENCE THE DIFFERENCE TODAY
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="why-most-list">
                      <ul>
                        <li className="list1">
                          <span className="list-counting">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16 8.89258V5.89258L19 2.89258L20 4.89258L22 5.89258L19 8.89258H16ZM16 8.89258L12 12.8925M22 12.8926C22 18.4154 17.5228 22.8926 12 22.8926C6.47715 22.8926 2 18.4154 2 12.8926C2 7.36973 6.47715 2.89258 12 2.89258M17 12.8926C17 15.654 14.7614 17.8926 12 17.8926C9.23858 17.8926 7 15.654 7 12.8926C7 10.1312 9.23858 7.89258 12 7.89258" stroke="#7F56D9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          </span>
                          <div>
                            <h3 className="fw-700">
                              GAIN REAL EXAM EXPERIENCE
                            </h3>
                            <p>                                
                              Experience the exact pressure, timing, and interface of the actual PTE test before your official exam day.
                            </p>
                          </div>
                        </li>
                        <li className="list2">
                          <span className="list-counting">
                            <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 1.16211V5.29265C11 5.8527 11 6.13273 11.109 6.34664C11.2049 6.5348 11.3578 6.68778 11.546 6.78366C11.7599 6.89265 12.0399 6.89265 12.6 6.89265H16.7305M11 15.8926H5M13 11.8926H5M17 8.8808V16.0926C17 17.7727 17 18.6128 16.673 19.2545C16.3854 19.819 15.9265 20.278 15.362 20.5656C14.7202 20.8926 13.8802 20.8926 12.2 20.8926H5.8C4.11984 20.8926 3.27976 20.8926 2.63803 20.5656C2.07354 20.278 1.6146 19.819 1.32698 19.2545C1 18.6128 1 17.7727 1 16.0926V5.69258C1 4.01242 1 3.17234 1.32698 2.53061C1.6146 1.96612 2.07354 1.50718 2.63803 1.21956C3.27976 0.892578 4.11984 0.892578 5.8 0.892578H9.01178C9.74555 0.892578 10.1124 0.892578 10.4577 0.975468C10.7638 1.04896 11.0564 1.17017 11.3249 1.33466C11.6276 1.52018 11.887 1.77961 12.4059 2.29847L15.5941 5.48669C16.113 6.00555 16.3724 6.26497 16.5579 6.56772C16.7224 6.83614 16.8436 7.12877 16.9171 7.43488C17 7.78015 17 8.14703 17 8.8808Z" stroke="#0286FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </span>
                          <div>
                            <h3 className="fw-700">IDENTIFY YOUR WEAK AREAS</h3>
                            <p>Detailed analytics reveal precisely which question types and skills need improvement, saving you valuable study time.</p>
                          </div>
                        </li>
                        <li className="list4">
                          <span className="list-counting">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 6.89258V12.8926L16 14.8926M22 12.8926C22 18.4154 17.5228 22.8926 12 22.8926C6.47715 22.8926 2 18.4154 2 12.8926C2 7.36973 6.47715 2.89258 12 2.89258C17.5228 2.89258 22 7.36973 22 12.8926Z" stroke="#FFB02C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </span>
                          <div>
                            <h3 className="fw-700">
                              MASTER TIME MANAGEMENT
                            </h3>
                            <p>
                              Learn to pace yourself effectively across all sections, ensuring you complete every question within the allocated time.
                            </p>
                          </div>
                        </li>
                        <li className="list3">
                          <span className="list-counting">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2.89258L14.012 8.12366C14.294 8.85689 14.435 9.22351 14.6542 9.53189C14.8486 9.8052 15.0874 10.044 15.3607 10.2383C15.6691 10.4576 16.0357 10.5986 16.7689 10.8806L22 12.8926L16.7689 14.9045C16.0357 15.1865 15.6691 15.3276 15.3607 15.5468C15.0874 15.7412 14.8486 15.98 14.6542 16.2533C14.435 16.5616 14.294 16.9283 14.012 17.6615L12 22.8926L9.98804 17.6615C9.70603 16.9283 9.56503 16.5616 9.34575 16.2533C9.15141 15.98 8.91262 15.7412 8.63931 15.5468C8.33093 15.3276 7.96432 15.1865 7.23109 14.9045L2 12.8926L7.23108 10.8806C7.96431 10.5986 8.33093 10.4576 8.63931 10.2383C8.91262 10.044 9.15141 9.8052 9.34575 9.53189C9.56503 9.22351 9.70603 8.85689 9.98804 8.12366L12 2.89258Z" stroke="#94C23C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          </span>
                          <div>
                            <h3 className="fw-700">BUILD UNSHAKEABLE CONFIDENCE</h3>
                            <p>Familiarity with the test format eliminates surprises and reduces test-day anxiety.</p>
                          </div>
                        </li>
                        <li className="list2">
                          <span className="list-counting">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.5 4.39258V2.89258M19.4393 5.45324L20.5 4.39258M20.5103 9.39258H22.0103M21.9506 13.8926C21.4489 18.9459 17.1853 22.8926 12 22.8926C6.47715 22.8926 2 18.4154 2 12.8926C2 7.70723 5.94668 3.44368 11 2.94195M12 8.89258H16V12.8926M15.6197 8.89258C13.2653 12.2202 9.38636 14.3926 5 14.3926C3.9971 14.3926 3.02072 14.279 2.08302 14.064" stroke="#0286FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </span>
                          <div>
                            <h3 className="fw-700">TRACK YOUR PROGRESS</h3>
                            <p>Monitor your improvement over time with detailed score reports and performance trends.</p>                              
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="why-choosing-section vc-master-aspect mt-la">
              <div className="container">
                <div className="row">
                  <h2 className="primary-heading text-center fw-700">
                    LANGUAGE ACADEMY'S
                    <br />
                    <span className="wpl-badge gold-badge text-white">
                      AI-POWERED <br className="d-block d-md-none" /> MOCK TEST
                    </span>
                    <br />
                    PLATFORM
                  </h2>
                  <p className="text-center fw-400">
                    Our revolutionary mock test platform uses advanced artificial intelligence <br className="d-none d-md-block" /> to provide the most accurate PTE preparation experience available in Australia.
                  </p>
                  <div className="feature-cards four-cards d-none d-md-grid">
                    <div className="feature-card card1">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 2.86328L14.012 8.09437C14.294 8.8276 14.435 9.19421 14.6542 9.50259C14.8486 9.7759 15.0874 10.0147 15.3607 10.209C15.6691 10.4283 16.0357 10.5693 16.7689 10.8513L22 12.8633L16.7689 14.8752C16.0357 15.1572 15.6691 15.2983 15.3607 15.5175C15.0874 15.7119 14.8486 15.9507 14.6542 16.224C14.435 16.5324 14.294 16.899 14.012 17.6322L12 22.8633L9.98804 17.6322C9.70603 16.899 9.56503 16.5324 9.34575 16.224C9.15141 15.9507 8.91262 15.7119 8.63931 15.5175C8.33093 15.2983 7.96432 15.1572 7.23109 14.8752L2 12.8633L7.23108 10.8513C7.96431 10.5693 8.33093 10.4283 8.63931 10.209C8.91262 10.0147 9.15141 9.7759 9.34575 9.50259C9.56503 9.19421 9.70603 8.8276 9.98804 8.09437L12 2.86328Z" stroke="#7F56D9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <h3>AUTOMATED SCORING TECHNOLOGY</h3>
                      <ul>
                        <li>
                          <h4>
                            <span className="circle"></span> Exact Algorithm Replication
                          </h4>
                          <p>
                            Our AI mirrors the actual PTE scoring system
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Instant Results
                          </h4>
                          <p>
                            Receive your scores within seconds of completion
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Precision Accuracy
                          </h4>
                          <p>
                            99.7% correlation with actual PTE scores
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="feature-card card2">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20 19.8633V16.8633H7C5.34315 16.8633 4 18.2064 4 19.8633M8.8 22.8633H16.8C17.9201 22.8633 18.4802 22.8633 18.908 22.6453C19.2843 22.4535 19.5903 22.1476 19.782 21.7713C20 21.3434 20 20.7834 20 19.6633V6.06328C20 4.94318 20 4.38312 19.782 3.9553C19.5903 3.57898 19.2843 3.27301 18.908 3.08127C18.4802 2.86328 17.9201 2.86328 16.8 2.86328H8.8C7.11984 2.86328 6.27976 2.86328 5.63803 3.19026C5.07354 3.47788 4.6146 3.93682 4.32698 4.50131C4 5.14305 4 5.98312 4 7.66328V18.0633C4 19.7434 4 20.5835 4.32698 21.2253C4.6146 21.7897 5.07354 22.2487 5.63803 22.5363C6.27976 22.8633 7.11984 22.8633 8.8 22.8633Z" stroke="#94C23C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <h3>COMPREHENSIVE TEST VARIETIES</h3>
                      <ul>
                        <li>
                          <h4>
                            <span className="circle"></span> Full-Length Mock Tests
                          </h4>
                          <p>
                            Complete 3-hour examinations with all sections
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Sectional Practice Tests
                          </h4>
                          <p>
                            Focus on specific skills (Reading, Writing, Listening, Speaking)
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Question-Type Specific Tests
                          </h4>
                          <p>
                            Target individual question formats for intensive practice
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="feature-card card3">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 21.8633L11.8999 21.7132C11.2053 20.6712 10.858 20.1503 10.3991 19.7731C9.99286 19.4392 9.52476 19.1887 9.02161 19.0359C8.45325 18.8633 7.82711 18.8633 6.57482 18.8633H5.2C4.07989 18.8633 3.51984 18.8633 3.09202 18.6453C2.71569 18.4535 2.40973 18.1476 2.21799 17.7713C2 17.3434 2 16.7834 2 15.6633V7.06328C2 5.94318 2 5.38312 2.21799 4.9553C2.40973 4.57898 2.71569 4.27301 3.09202 4.08127C3.51984 3.86328 4.07989 3.86328 5.2 3.86328H5.6C7.84021 3.86328 8.96031 3.86328 9.81596 4.29926C10.5686 4.68275 11.1805 5.29467 11.564 6.04732C12 6.90297 12 8.02307 12 10.2633M12 21.8633V10.2633M12 21.8633L12.1001 21.7132C12.7947 20.6712 13.142 20.1503 13.6009 19.7731C14.0071 19.4392 14.4752 19.1887 14.9784 19.0359C15.5467 18.8633 16.1729 18.8633 17.4252 18.8633H18.8C19.9201 18.8633 20.4802 18.8633 20.908 18.6453C21.2843 18.4535 21.5903 18.1476 21.782 17.7713C22 17.3434 22 16.7834 22 15.6633V7.06328C22 5.94318 22 5.38312 21.782 4.9553C21.5903 4.57898 21.2843 4.27301 20.908 4.08127C20.4802 3.86328 19.9201 3.86328 18.8 3.86328H18.4C16.1598 3.86328 15.0397 3.86328 14.184 4.29926C13.4314 4.68275 12.8195 5.29467 12.436 6.04732C12 6.90297 12 8.02307 12 10.2633" stroke="#0286FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <h3>DETAILED PERFORMANCE ANALYTICS</h3>
                      <ul>
                        <li>
                          <h4>
                            <span className="circle"></span> Individual Question Analysis
                          </h4>
                          <p>
                            Understand exactly where points were lost
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Skill-Based Breakdown
                          </h4>
                          <p>
                            See performance across all four core competencies
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Progress Tracking
                          </h4>
                          <p>
                            Monitor improvement trends over multiple attempts
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="feature-card card4">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.5 10.8633L9.5 13.8633L15.5 7.86328M21 10.8633C21 16.3861 16.5228 20.8633 11 20.8633C5.47715 20.8633 1 16.3861 1 10.8633C1 5.34043 5.47715 0.863281 11 0.863281C16.5228 0.863281 21 5.34043 21 10.8633Z" stroke="#FFB02C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <h3>VERIFIED QUESTION BANK</h3>
                      <ul>
                        <li>
                          <h4>
                            <span className="circle"></span> 11,000+ Practice Questions
                          </h4>
                          <p>
                            Extensive library covering all PTE question types
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Real Exam Similarity
                          </h4>
                          <p>
                            Questions modeled on actual PTE test patterns
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Regular Updates
                          </h4>
                          <p>
                            Content refreshed to reflect current exam trends
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
  
                  {/* Mobile HTML */}
                  <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                    <Slider {...CardsSlider} className="feature-cards four-cards">
                      <div className="feature-card card1">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 2.86328L14.012 8.09437C14.294 8.8276 14.435 9.19421 14.6542 9.50259C14.8486 9.7759 15.0874 10.0147 15.3607 10.209C15.6691 10.4283 16.0357 10.5693 16.7689 10.8513L22 12.8633L16.7689 14.8752C16.0357 15.1572 15.6691 15.2983 15.3607 15.5175C15.0874 15.7119 14.8486 15.9507 14.6542 16.224C14.435 16.5324 14.294 16.899 14.012 17.6322L12 22.8633L9.98804 17.6322C9.70603 16.899 9.56503 16.5324 9.34575 16.224C9.15141 15.9507 8.91262 15.7119 8.63931 15.5175C8.33093 15.2983 7.96432 15.1572 7.23109 14.8752L2 12.8633L7.23108 10.8513C7.96431 10.5693 8.33093 10.4283 8.63931 10.209C8.91262 10.0147 9.15141 9.7759 9.34575 9.50259C9.56503 9.19421 9.70603 8.8276 9.98804 8.09437L12 2.86328Z" stroke="#7F56D9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <h3>AUTOMATED SCORING TECHNOLOGY</h3>
                      <ul>
                        <li>
                          <h4>
                            <span className="circle"></span> Exact Algorithm Replication
                          </h4>
                          <p>
                            Our AI mirrors the actual PTE scoring system
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Instant Results
                          </h4>
                          <p>
                            Receive your scores within seconds of completion
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Precision Accuracy
                          </h4>
                          <p>
                            99.7% correlation with actual PTE scores
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="feature-card card2">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20 19.8633V16.8633H7C5.34315 16.8633 4 18.2064 4 19.8633M8.8 22.8633H16.8C17.9201 22.8633 18.4802 22.8633 18.908 22.6453C19.2843 22.4535 19.5903 22.1476 19.782 21.7713C20 21.3434 20 20.7834 20 19.6633V6.06328C20 4.94318 20 4.38312 19.782 3.9553C19.5903 3.57898 19.2843 3.27301 18.908 3.08127C18.4802 2.86328 17.9201 2.86328 16.8 2.86328H8.8C7.11984 2.86328 6.27976 2.86328 5.63803 3.19026C5.07354 3.47788 4.6146 3.93682 4.32698 4.50131C4 5.14305 4 5.98312 4 7.66328V18.0633C4 19.7434 4 20.5835 4.32698 21.2253C4.6146 21.7897 5.07354 22.2487 5.63803 22.5363C6.27976 22.8633 7.11984 22.8633 8.8 22.8633Z" stroke="#94C23C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <h3>COMPREHENSIVE TEST VARIETIES</h3>
                      <ul>
                        <li>
                          <h4>
                            <span className="circle"></span> Full-Length Mock Tests
                          </h4>
                          <p>
                            Complete 3-hour examinations with all sections
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Sectional Practice Tests
                          </h4>
                          <p>
                            Focus on specific skills (Reading, Writing, Listening, Speaking)
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Question-Type Specific Tests
                          </h4>
                          <p>
                            Target individual question formats for intensive practice
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="feature-card card3">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 21.8633L11.8999 21.7132C11.2053 20.6712 10.858 20.1503 10.3991 19.7731C9.99286 19.4392 9.52476 19.1887 9.02161 19.0359C8.45325 18.8633 7.82711 18.8633 6.57482 18.8633H5.2C4.07989 18.8633 3.51984 18.8633 3.09202 18.6453C2.71569 18.4535 2.40973 18.1476 2.21799 17.7713C2 17.3434 2 16.7834 2 15.6633V7.06328C2 5.94318 2 5.38312 2.21799 4.9553C2.40973 4.57898 2.71569 4.27301 3.09202 4.08127C3.51984 3.86328 4.07989 3.86328 5.2 3.86328H5.6C7.84021 3.86328 8.96031 3.86328 9.81596 4.29926C10.5686 4.68275 11.1805 5.29467 11.564 6.04732C12 6.90297 12 8.02307 12 10.2633M12 21.8633V10.2633M12 21.8633L12.1001 21.7132C12.7947 20.6712 13.142 20.1503 13.6009 19.7731C14.0071 19.4392 14.4752 19.1887 14.9784 19.0359C15.5467 18.8633 16.1729 18.8633 17.4252 18.8633H18.8C19.9201 18.8633 20.4802 18.8633 20.908 18.6453C21.2843 18.4535 21.5903 18.1476 21.782 17.7713C22 17.3434 22 16.7834 22 15.6633V7.06328C22 5.94318 22 5.38312 21.782 4.9553C21.5903 4.57898 21.2843 4.27301 20.908 4.08127C20.4802 3.86328 19.9201 3.86328 18.8 3.86328H18.4C16.1598 3.86328 15.0397 3.86328 14.184 4.29926C13.4314 4.68275 12.8195 5.29467 12.436 6.04732C12 6.90297 12 8.02307 12 10.2633" stroke="#0286FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <h3>DETAILED PERFORMANCE ANALYTICS</h3>
                      <ul>
                        <li>
                          <h4>
                            <span className="circle"></span> Individual Question Analysis
                          </h4>
                          <p>
                            Understand exactly where points were lost
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Skill-Based Breakdown
                          </h4>
                          <p>
                            See performance across all four core competencies
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Progress Tracking
                          </h4>
                          <p>
                            Monitor improvement trends over multiple attempts
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="feature-card card4">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.5 10.8633L9.5 13.8633L15.5 7.86328M21 10.8633C21 16.3861 16.5228 20.8633 11 20.8633C5.47715 20.8633 1 16.3861 1 10.8633C1 5.34043 5.47715 0.863281 11 0.863281C16.5228 0.863281 21 5.34043 21 10.8633Z" stroke="#FFB02C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <h3>VERIFIED QUESTION BANK</h3>
                      <ul>
                        <li>
                          <h4>
                            <span className="circle"></span> 11,000+ Practice Questions
                          </h4>
                          <p>
                            Extensive library covering all PTE question types
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Real Exam Similarity
                          </h4>
                          <p>
                            Questions modeled on actual PTE test patterns
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Regular Updates
                          </h4>
                          <p>
                            Content refreshed to reflect current exam trends
                          </p>
                        </li>
                      </ul>
                    </div>
                    </Slider>
                  </div>
  
                  <div className="text-center">
                    <Link to="/auth/register" className="primary-btn">
                      UNLOCK YOUR POTENTIAL WITH OUR PLATFORM
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-four-pte">
              <div className="master-all-pte">
                <div className="container">                        
                  <div className="row">
                    <div className="master-all-header">
                      <h2 className="primary-heading fw-700 text-center text-white">                        
                        COMPLETE MOCK <br /> TESTS FOR ALL <br className="d-block d-md-none" /> <span className="wpl-badge text-white">4 PTE SECTIONS</span>        
                      </h2> 
                      <p className="sub-heading text-center text-white">Our specialized training helps you excel in every <br className="d-none d-md-block" /> component of the PTE Core exam</p> 
                    </div>
                  </div>
                  <div className="master-all-tabs">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="speak-tab" data-bs-toggle="tab" data-bs-target="#speak-tab-pane" type="button" role="tab" aria-controls="speak-tab-pane" aria-selected="true"><img src="/images/web-new-images/icons/w-speak-icon.svg" alt="Register Now" /> Speaking                          
                        </button>
                      </li> 
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" id="write-tab" data-bs-toggle="tab" data-bs-target="#write-tab-pane" type="button" role="tab" aria-controls="write-tab-pane" aria-selected="false"><img src="/images/web-new-images/icons/w-write-icon.svg" alt="Register Now" /> Writing                          
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false"><img src="/images/web-new-images/icons/w-reading-icon.svg" alt="Register Now" /> Reading                          
                        </button>
                      </li>  
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="false"><img src="/images/web-new-images/icons/w-listen-icon.svg" alt="Register Now" /> Listening                          
                        </button>
                      </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                      <div className="tab-pane fade show active" id="speak-tab-pane" role="tabpanel" aria-labelledby="speak-tab" tabIndex="0">
                        <div className="master-tab-cards">
                            <div className="test-card">
                              <h2>What It Tests</h2>
                              <ul>
                                <li>Pronunciation, fluency, and <br /> oral communication clarity</li>
                              </ul>
                            </div>
                            <div className="approach-card">
                              <div className="card-img">
                                <img src="/images/web-new-images/icons/w-speak-icon.svg" alt="Register Now" />
                              </div>
                              <h2>Our Approach</h2>
                              <ul>
                                <li>High-quality microphone calibration for accurate assessment</li>
                                <li>Real-time pronunciation feedback using advanced speech recognition</li>
                                <li>Fluency analysis that mirrors PTE's evaluation criteria</li>
                              </ul>
                              <h3 className="sub-sub-title my-4 text-white">Question Types Covered</h3>
                              <ul>
                                <li>Read Aloud, Repeat Sentence, Describe Image, Respond To Situation, Answer Short Questions</li>
                              </ul>
                            </div>
                          </div>
                      </div>   
                      <div className="tab-pane fade" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabIndex="0">
                          <div className="master-tab-cards">
                            <div className="test-card">
                              <h2>What It Tests</h2>
                              <ul>
                                <li>Audio comprehension, note-taking, <br className="d-none d-md-block" /> and information processing</li>
                              </ul>
                            </div>
                            <div className="approach-card">
                              <div className="card-img">
                                <img src="/images/web-new-images/icons/w-listen-icon.svg" alt="Register Now" />
                              </div>
                              <h2>Our Approach</h2>
                              <ul>
                                <li>Authentic accent variations for realistic preparation</li>
                                <li>Note-taking strategies for complex audio passages</li>
                                <li>Focus training for key information identification</li>
                              </ul>
                              <h3 className="sub-sub-title text-white my-4">Question Types Covered</h3>
                              <ul>
                                <li>Summarize Spoken Text, Fill in the Blanks, Multiple Choice, Write from Dictation</li>
                              </ul>
                            </div>
                          </div>
                      </div>
                      <div className="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabIndex="0">
                        <div className="master-tab-cards">
                            <div className="test-card">
                              <h2>What It Tests</h2>
                              <ul>
                                <li>Comprehension, vocabulary knowledge, and analytical thinking</li>
                              </ul>
                            </div>
                            <div className="approach-card">
                              <div className="card-img">
                                <img src="/images/web-new-images/icons/w-reading-icon.svg" alt="Register Now" />
                              </div>
                              <h2>Our Approach</h2>
                              <ul>
                                <li>Speed reading techniques integrated into practice</li>
                                <li>Vocabulary building exercises within context</li>
                                <li>Strategic approaches for different question formats</li>
                              </ul>
                              <h3 className="sub-sub-title text-white my-4">Question Types Covered</h3>
                              <ul>
                                <li>Fill in the Blanks, Multiple Choice, Re-order Paragraphs</li>
                              </ul>
                            </div>
                          </div>
                      </div>                  
                      <div className="tab-pane fade" id="write-tab-pane" role="tabpanel" aria-labelledby="write-tab" tabIndex="0">
                        <div className="master-tab-cards">
                            <div className="test-card">
                              <h2>What It Tests</h2>
                              <ul>
                                <li>Essay composition, text summarization, and grammatical accuracy</li>
                              </ul>
                            </div>
                            <div className="approach-card">
                              <div className="card-img">
                                <img src="/images/web-new-images/icons/w-write-icon.svg" alt="Register Now" />
                              </div>
                              <h2>Our Approach</h2>
                              <ul>
                                <li>Template-based essay strategies for consistent high scores</li>
                                <li>Automated grammar and spelling analysis</li>
                                <li>Time management tools for efficient writing</li>
                              </ul>
                              <h3 className="sub-sub-title text-white my-4">Question Types Covered</h3>
                              <ul>
                                <li>Summarize Written Text, Write Email</li>
                              </ul>
                            </div>
                          </div>
                      </div>                 
                                    
                    </div>           
                  </div>
                  <div className="row">                  
                    <div className="col-md-12 text-center">
                        <Link className="primary-btn" to="/auth/register">
                            <span className="btn-inner">
                              PRACTICE ALL SECTIONS TODAY <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                            </span>
                        </Link>
                    </div>
                  </div> 
                </div>
              </div> 
              <div className="mt-scoring-advantage">
                <div className="container">
                  <div className="row">
                    <h2 className="primary-heading text-white text-center fw-700">
                      <span className="wpl-badge pte-naati-badge text-white">
                        the LANGUAGE <br className="d-block d-md-none" /> ACADEMY
                      </span>
                      <br className="d-block" />SCORING ADVANTAGE
                    </h2>
                    <h3 className="sub-title fw-600 text-white text-center">5-STEP PRECISION SCORING PROCESS</h3>
                    <div className="plan-cards d-none d-md-flex">
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>AUTOMATED <br />SCORING</h2>
                            <p>
                              Your responses are instantly evaluated using our proprietary AI system that replicates PTE's actual scoring algorithms.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>EXPERT <br /> SCORE REVIEW</h2>
                            <p>
                              Certified PTE trainers analyze your results to identify specific improvement opportunities.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>DETAILED SCORECARD <br /> GENERATION</h2>
                            <p>
                              In-depth reports show your performance across all skills and question types.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>PERSONALIZED <br />FEEDBACK DELIVERY</h2>
                            <p>
                              Targeted recommendations help you focus your study efforts where they'll have maximum impact.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>ONGOING <br />TUTOR SUPPORT</h2>
                            <p>
                              Expert guidance available to help you implement improvement strategies effectively.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="slider-dot-arrow d-block d-md-none transparent-arrows mobile-slider">
                      <Slider {...CardsSlider} className="plan-cards">
                        <div className="plan-card-outer">
                            <div className="plan-card">
                              <div className="icon-wrapper">
                                <svg
                                  width="18"
                                  height="14"
                                  viewBox="0 0 18 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M17 1.49072L6 12.4907L1 7.49072"
                                    stroke="#48A75C"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                              <div className="content-wrapper">
                                <h2>AUTOMATED <br />SCORING</h2>
                                <p>
                                  Your responses are instantly evaluated using our proprietary AI system that replicates PTE's actual scoring algorithms.
                                </p>
                              </div>
                            </div>
                        </div>
                        <div className="plan-card-outer">
                          <div className="plan-card">
                            <div className="icon-wrapper">
                              <svg
                                width="18"
                                height="14"
                                viewBox="0 0 18 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17 1.49072L6 12.4907L1 7.49072"
                                  stroke="#48A75C"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                            <div className="content-wrapper">
                              <h2>EXPERT <br /> SCORE REVIEW</h2>
                              <p>
                                Certified PTE trainers analyze your results to identify specific improvement opportunities.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="plan-card-outer">
                          <div className="plan-card">
                            <div className="icon-wrapper">
                              <svg
                                width="18"
                                height="14"
                                viewBox="0 0 18 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17 1.49072L6 12.4907L1 7.49072"
                                  stroke="#48A75C"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                            <div className="content-wrapper">
                              <h2>DETAILED SCORECARD <br /> GENERATION</h2>
                              <p>
                                In-depth reports show your performance across all skills and question types.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="plan-card-outer">
                          <div className="plan-card">
                            <div className="icon-wrapper">
                              <svg
                                width="18"
                                height="14"
                                viewBox="0 0 18 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17 1.49072L6 12.4907L1 7.49072"
                                  stroke="#48A75C"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                            <div className="content-wrapper">
                              <h2>PERSONALIZED <br />FEEDBACK DELIVERY</h2>
                              <p>
                                Targeted recommendations help you focus your study efforts where they'll have maximum impact.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="plan-card-outer">
                          <div className="plan-card">
                            <div className="icon-wrapper">
                              <svg
                                width="18"
                                height="14"
                                viewBox="0 0 18 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17 1.49072L6 12.4907L1 7.49072"
                                  stroke="#48A75C"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                            <div className="content-wrapper">
                              <h2>ONGOING <br />TUTOR SUPPORT</h2>
                              <p>
                                Expert guidance available to help you implement improvement strategies effectively.
                              </p>
                            </div>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                </div>
              </div> 
              <div className="container">
                <div className="row">
                  <div className="pc-skill-areas">
                      <h2 className="pc-pte-core-title text-white">
                        WHAT MAKES OUR SCORING UNIQUE
                      </h2>
                      <div className="skill-areas-content mb-0">
                        <div className="left-area">
                          <ul>
                            <li>Question-Wise Feedback</li>
                            <li>Trend Analysis</li>
                            <li>Skill Mapping</li>
                            <li>Instant Delivery</li>
                          </ul>
                        </div>
                        <div className="right-area">
                          <ul>
                            <li>Understand exactly what went wrong with each response</li>
                            <li>Track your improvement patterns over multiple attempts</li>
                            <li>See how each question type affects your overall score</li>
                            <li>No waiting – get your results immediately after completion</li>
                          </ul>
                        </div>
                      </div>
                      <div className="text-center">
                        <Link className="primary-btn mt-0" to="/auth/register">
                          <span className="btn-inner">
                            GET YOUR DETAILED SCORE ANALYSIS
                            <img
                              src="/images/web-new-images/right-arrow.svg"
                              alt="Register Now"
                            />
                          </span>
                        </Link>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-success-stories"> 
              <div className="container">                        
                <div className="row">
                  <h2 className="primary-heading fw-700 text-center">                        
                    OUR STUDENT <br /> <span className="wpl-badge gold-badge text-white">SUCCESS STORIES</span>        
                  </h2> 
                  <div className="pc-skill-areas">
                    <div className="skill-areas-header">
                        <h3 className="d-flex align-items-center"><span className="circle me-2"></span> Outstanding Achievement Rate</h3>
                        <p>14 out of 15 students score 90+ after using our mock test platform</p>
                    </div>                    
                    <h2 className="pc-pte-core-title fw-600">
                      IMPRESSIVE PERFORMANCE METRICS
                    </h2>
                    <div className="skill-areas-content">
                      <div className="left-area">
                        <ul>
                          <li>500,000+ Members</li>
                          <li>11,000+ Practice Questions</li>
                          <li>3,000+ Mock Tests</li>
                          <li>35,000+ Daily Sign-ins</li>
                        </ul>
                      </div>
                      <div className="right-area">
                        <ul>
                          <li>have trusted our platform for their PTE preparation</li>
                          <li>provide comprehensive coverage of all exam areas</li>
                          <li>completed daily by students worldwide</li>
                          <li>demonstrate the platform's effectiveness and popularity</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="sss-section">
              <CrackedCodeSlider title={`<span className="fw-700">HEAR FROM OUR</span> <br className="d-block" /><span className="wpl-badge pte-naati-badge text-white">SUCCESSFUL STUDENTS</span>`} />
              <div className="container">
                <div className="text-center mt-4">                  
                  <Link to="#" className="primary-btn">
                    JOIN OUR SUCCESS COMMUNITY
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </Link>
                </div>
              </div>
            </div>

            <div className="mt-test-package">
              <div className="container">
                <h2 className="primary-heading fw-600 text-center text-white">                        
                  CHOOSE YOUR <br /><span className="wpl-badge text-white">MOCK TEST PACKAGE</span>        
                </h2>
                <h3 className="sub-title fw-500 text-center">Starting from $89 - Unlimited Access <br className="d-none d-md-block" /> to Australia's Most Accurate PTE Mock Tests</h3>
                <div className="mt-test-cards">
                  <div className="mt-test-card">
                    <h2>SILVER <br /> PACKAGE</h2>
                    <ul>
                      <li>
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1.95361L6 12.9536L1 7.95361" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span><strong className="fw-700">Unlimited AI Scoring</strong> for all question types</span>
                      </li>
                      <li>
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1.95361L6 12.9536L1 7.95361" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span><strong className="fw-700">Full Access</strong> to 11,000+ exam questions</span>
                      </li>
                      <li>
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1.95361L6 12.9536L1 7.95361" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span><strong className="fw-700">Latest Templates</strong> and prediction files</span>
                      </li>
                      <li>
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1.95361L6 12.9536L1 7.95361" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span><strong className="fw-700">Unlimited Sectional Mock Tests</strong> with detailed scoring</span>
                      </li>
                      <li>
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1.95361L6 12.9536L1 7.95361" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span><strong className="fw-700">Unlimited Full-Length Mock Tests</strong> with comprehensive analysis</span>
                      </li>
                      <li>
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1.95361L6 12.9536L1 7.95361" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span><strong className="fw-700">Unlimited Comprehensive Mock Tests</strong> with expert insights</span>
                      </li>
                    </ul>
                  </div>
                  <div className="mt-test-card">
                    <h2>GOLD <br /> PACKAGE <span className="seller-badge">Best Seller</span></h2>
                    <ul>
                      <li className="fw-600">Everything in Silver Package, PLUS</li>
                      <li className="fw-700">
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1.95361L6 12.9536L1 7.95361" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Access to Reading Explanation Videos</span>
                      </li>
                      <li className="fw-700">
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1.95361L6 12.9536L1 7.95361" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Full Access to Premium Strategy Videos</span>
                      </li>
                      <li className="fw-700">
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1.95361L6 12.9536L1 7.95361" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Complete Detailed Video Course Library</span>
                      </li>
                      <li className="fw-700">
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1.95361L6 12.9536L1 7.95361" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Priority Expert Support</span>
                      </li>
                      <li className="fw-700">
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1.95361L6 12.9536L1 7.95361" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Advanced Analytics Dashboard</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="mt-test-pricing">
                  <h2 className="primary-heading fw-700 text-center text-white">PRICING OPTIONS</h2>
                  <div className="mt-test-pricing-cards d-none d-md-grid">
                    <div className="pricing-card">
                      <h2>Duration</h2>
                      <p>1 Month</p>
                      <p>2 Month</p>
                      <p>3 Month</p>
                    </div>
                    <div className="pricing-card">
                      <h2>Original Price</h2>
                      <p className="fw-700">AUD $89</p>
                      <p className="fw-700">AUD $178</p>
                      <p className="fw-700">AUD $267</p>
                    </div>
                    <div className="pricing-card">
                      <h2>Discounted Price</h2>
                      <p className="price-badge one">AUD $89</p>
                      <p className="price-badge two">AUD $119</p>
                      <p className="price-badge three">AUD $139</p>
                    </div>
                    <div className="pricing-card">
                      <h2>Savings</h2>
                      <p>Perfect for intensive prep</p>
                      <p>Save 33% - Most Popular</p>
                      <p>Save 48% - Maximum Savings</p>
                    </div>
                  </div>

                  <div className="transparent-arrows mt-ptecore ptecore-othertest-slider slider-dot-arrow d-block d-md-none">                    
                    <Slider {...CardSlider}>
                      <div className="pc-mobile-card">
                      <div className="pc-mobile-card-header">
                        <h2 className="title">Duration</h2>
                        <h2 className="sub-title">1 Month</h2>
                      </div>
                      <div className="pc-mobile-card-content">
                        <ul>
                          <li>
                            <span className="left-col">Original Price</span>
                            <span className="right-col title">AUD $89</span>
                          </li>
                          <li>
                            <span className="left-col">Discounted Price</span>
                            <span className="right-col badge">AUD $89</span>
                          </li>
                          <li>
                            <span className="left-col">Savings</span>
                            <span className="right-col">Perfect for intensive prep</span>
                          </li>
                        </ul>
                      </div>
                      </div>
                        <div className="pc-mobile-card">
                          <div className="pc-mobile-card-header">
                            <h2 className="title">Duration</h2>
                            <h2 className="sub-title">2 Month</h2>
                          </div>
                          <div className="pc-mobile-card-content">
                             <ul>
                                <li>
                                  <span className="left-col">Original Price</span>
                                  <span className="right-col title">AUD $178</span>
                                </li>
                                <li>
                                  <span className="left-col">Discounted Price</span>
                                  <span className="right-col badge two">AUD $119</span>
                                </li>
                                <li>
                                  <span className="left-col">Savings</span>
                                  <span className="right-col">Save 33% - Most Popular</span>
                                </li>
                              </ul>
                          </div>
                      </div>
                        <div className="pc-mobile-card">
                          <div className="pc-mobile-card-header">
                            <h2 className="title">Duration</h2>
                            <h2 className="sub-title">3 Month</h2>
                          </div>
                          <div className="pc-mobile-card-content">
                            <ul>
                              <li>
                                <span className="left-col">Original Price</span>
                                <span className="right-col title">AUD $267</span>
                              </li>
                              <li>
                                <span className="left-col">Discounted Price</span>
                                <span className="right-col badge three">AUD $139</span>
                              </li>
                              <li>
                                <span className="left-col">Savings</span>
                                <span className="right-col">Save 48% - Maximum Savings</span>
                              </li>
                            </ul>
                          </div>
                      </div>
                    </Slider>
                  </div>


                  <p className="sub-title fw-300 text-center">All packages auto-renew. Cancel anytime.</p>
                  <div className="text-center mt-4">                   
                    <Link to="#" className="primary-btn">
                      SELECT YOUR PACKAGE
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

             <div className="pc-why-choose np-need-crack">
              <div className="container">
                <div className="row why-most-second-row">
                  <div className="col-lg-6 why-most-content">
                    <h2 className="primary-heading fw-700 mb-0">
                      HOW TO ACCESS
                      <br /> 
                      <span className="wpl-badge  pte-naati-badge text-white">YOUR MOCK TESTS</span>
                    </h2>
                    <p className="sub-sub-title my-4 fw-500 text-center text-md-start">SIMPLE 4-STEP PROCESS</p>
                    <div className="text-center text-md-start">
                    <Link className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        START YOUR MOCK TEST JOURNEY
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="why-most-list">
                      <ul>
                        <li className="list1">
                          <span className="list-counting">
                            1
                          </span>
                          <div>
                            <h3 className="fw-700">
                              REGISTER & CHOOSE <br /> YOUR PACKAGE
                            </h3>
                            <p>                                
                              Select the mock test package that best fits your preparation timeline and goals.
                            </p>
                          </div>
                        </li>
                        <li className="list2">
                          <span className="list-counting">
                            2
                          </span>
                          <div>
                            <h3 className="fw-700">ACCESS THE LA PTE PORTAL</h3>
                            <p>Log into our user-friendly platform designed for optimal test-taking experience.</p>
                          </div>
                        </li>
                        <li className="list3">
                          <span className="list-counting">
                            3
                          </span>
                          <div>
                            <h3 className="fw-700">
                              TAKE YOUR MOCK TESTS
                            </h3>
                            <p>
                              Choose from full-length tests, sectional practice, or targeted question-type exercises.
                            </p>
                          </div>
                        </li>
                        <li className="list4">
                          <span className="list-counting">
                           4
                          </span>
                          <div>
                            <h3 className="fw-700">ANALYZE & IMPROVE</h3>
                            <p>Review your detailed results, implement feedback, and track your progress over time.</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-success-stories">
              <div className="container">
                <div className="row">
                  <div className="pc-skill-areas">                                      
                    <h2 className="pc-pte-core-title text-center fw-600">
                      AVAILABLE ANYTIME, ANYWHERE
                    </h2>
                    <div className="skill-areas-content">
                      <div className="left-area">
                        <ul>
                          <li>24/7 Platform Access</li>
                          <li>Mobile-Friendly Interface</li>
                          <li>Automatic Progress Sync</li>
                          <li>Result History Storage</li>
                        </ul>
                      </div>
                      <div className="right-area">
                        <ul>
                          <li>Practice whenever suits your schedule</li>
                          <li>Take tests on any device</li>
                          <li>Your data follows you across all devices</li>
                          <li>Access all previous attempts and track improvement</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center mt-4">
                  <Link to="#" className="primary-btn">
                    START YOUR MOCK TEST JOURNEY
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </Link>
                </div>
              </div>
            </div>
            
             <div className="faq-section mt-faq">
              <div className="container">
                <div className="row">
                  <h2 className="secondary-heading text-center">
                    Frequently Asked Questions
                  </h2>
                  <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          How many mock tests should I take for optimal preparation?
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          Most students achieve their best results after taking 15-25 full mock tests over 4-6 weeks. Our unlimited access ensures you can practice as much as needed without restrictions.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingTwo">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          How accurate are your mock test scores compared to the real PTE exam?
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          Lorem ipsum dolor sit amet consectetur adipisicing elit. Incidunt, eaque magnam, soluta corporis magni reprehenderit vero nemo dignissimos, excepturi delectus expedita dicta quam temporibus nobis! Doloremque beatae sapiente quasi modi.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingThree">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          Do you provide sectional mock tests or only full-length tests?
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex blanditiis, laudantium neque maxime optio sapiente impedit soluta. Laborum, et. Alias, provident. Nihil dignissimos aspernatur vel qui inventore odio optio? Quas.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingFour">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          How quickly do I receive my mock test results?
                        </button>
                      </h2>
                      <div
                        id="collapseFour"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingFour"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex blanditiis, laudantium neque maxime optio sapiente impedit soluta. Laborum, et. Alias, provident. Nihil dignissimos aspernatur vel qui inventore odio optio? Quas.
                        </div>
                      </div>
                    </div>

                     <div className="accordion-item">
                      <h2 className="accordion-header" id="headingFive">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          Can I retake the same mock test to see improvement?
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingFive"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex blanditiis, laudantium neque maxime optio sapiente impedit soluta. Laborum, et. Alias, provident. Nihil dignissimos aspernatur vel qui inventore odio optio? Quas.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingSix">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSix"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                        >
                          What's the difference between Silver and Gold packages?
                        </button>
                      </h2>
                      <div
                        id="collapseSix"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingSix"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex blanditiis, laudantium neque maxime optio sapiente impedit soluta. Laborum, et. Alias, provident. Nihil dignissimos aspernatur vel qui inventore odio optio? Quas.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingSeven">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSeven"
                          aria-expanded="false"
                          aria-controls="collapseSeven"
                        >
                          Do you offer customer support if I have technical issues?
                        </button>
                      </h2>
                      <div
                        id="collapseSeven"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingSeven"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex blanditiis, laudantium neque maxime optio sapiente impedit soluta. Laborum, et. Alias, provident. Nihil dignissimos aspernatur vel qui inventore odio optio? Quas.
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className="text-center mt-4">
                    <Link to="#" className="primary-btn">
                      READY TO START YOUR SUCCESS JOURNEY? BEGIN TODAY
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default FreeMockTest;
